// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-expansion-panel {
  -webkit-user-select: none;
          user-select: none;
  margin-top: 8px;
  margin-bottom: 8px;
}

mat-panel-title {
  font-size: 18px;
  color: #3e5777;
}

:host ::ng-deep.mat-expansion-panel-content {
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/base/hidable-text/hidable-text.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;UAAA,iBAAA;EACA,eAAA;EACA,kBAAA;AACJ;;AAEA;EACI,eAAA;EACA,cAAA;AACJ;;AAEA;EACI,eAAA;AACJ","sourcesContent":["mat-expansion-panel {\n    user-select: none;\n    margin-top: 8px;\n    margin-bottom: 8px;\n}\n\nmat-panel-title {\n    font-size: 18px;\n    color: #3e5777;\n}\n\n:host ::ng-deep.mat-expansion-panel-content {\n    font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
